import { combineReducers } from 'redux'
import { reducers } from '@telus/redux-contentful'
import profile from './profile'
import apiPartnerProfile from './apiPartnerProfile'
import apiCustomerProfile from './apiCustomerProfile'
import profileState from './partnerProfile'
import userAction from './userAction'

const { contentful } = reducers

const rootReducer = combineReducers({
  contentful,
  profile,
  userAction,
  apiPartnerProfile,
  apiCustomerProfile,
  profileState
})

export default rootReducer
